<template>
  <div class="btn-set">
    <div class="row">
      <div v-for="(chip, index) in mainChips" :key="index" class="btn-setbtn">
        <ChipButton
          v-if="shouldDisplayChip(chip.playload)"
          :content="chip.mainContent"
          :element-style="elementStyle"
          @click="sendMessage(chip.payload, chip.mainContent, chip.conversationId)"
        />
      </div>
      <div class="btn-setbtn">
        <ChipButton
          v-if="additionalChips.length"
          content="..."
          :element-style="elementStyle"
          @click="toggleAdditionalChips"
        />
      </div>
    </div>
    <div v-show="additionalChips.length && shouldDisplayAdditionalChips" class="row">
      <ul class="chips-dropdown">
        <template v-for="(chip, index) in additionalChips">
          <ChipButton
            v-if="shouldDisplayChip(chip.playload)"
            :key="index"
            tag-name="li"
            :content="chip.mainContent"
            :element-style="elementStyle"
            @click="sendMessage(chip.payload, chip.mainContent, chip.conversationId)"
          />
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChipButton from './ChipButton'
import config from '../../config'
import { sendMessage, shouldDisplayChip } from '../../lib/chipMessage'

export default {
  name: 'Chip',
  components: { ChipButton },
  props: {
    message: { type: Object, required: true },
    elementStyle: { type: [Object, Boolean], default: null },
    assistantId: { type: String, required: true },
    isAdmin: { type: Boolean, default: false },
    isKiosk: { type: Boolean, default: false }
  },
  data() {
    return {
      shouldDisplayAdditionalChips: false,
      shouldDisplayLocationPermissionError: false
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale'
    }),
    chips() {
      return this.message.chips || []
    },
    mainChips() {
      return this.chips.slice(0, config.MAX_NUMBER_DISPLAYED_QUICK_REPLIES)
    },
    additionalChips() {
      return this.chips.slice(config.MAX_NUMBER_DISPLAYED_QUICK_REPLIES)
    }
  },
  methods: {
    shouldDisplayChip,
    sendMessage(payload, mainContent, conversationId) {
      sendMessage(
        this.$store,
        payload,
        mainContent,
        config.SOURCE_TYPES.QUICK_REPLY,
        this.assistantId,
        this.$t('location_permission_error'),
        config.EVENT_ELEMENTS.LINK,
        this.isKiosk,
        conversationId
      )
    },
    toggleAdditionalChips() {
      this.shouldDisplayAdditionalChips = !this.shouldDisplayAdditionalChips

      // Scroll to display dropdown
      setTimeout(() => {
        document.getElementById('chatList').scrollTop = document.getElementById('chatList').scrollHeight
      }, 100)
    }
  }
}
</script>
